/**
 * @name THEME_ICONS
 * @description default icons values
 */
export const THEME_ICONS = {};
